import { createContext } from 'react'
import type { Clients } from '../utils/useCustomizationByURLParams'

type State = {
  client: Clients | null
  setClient: (client: Clients | null) => void
}

export const LayoutContext = createContext<State>({
  client: null,
  setClient: () => undefined,
})
